<template>
  <section class="info-flight-update">
    <div v-if="lang && lang['homepage_new']" class="index container">
      <div class="title-flight-update">
        <h2>{{ pax['covid19_portal']['1'].FLIGHT_UPDATE_CONFIRM_TITLE.replace('&lt;passenger_name&gt;', pax.full_name) }}</h2>
      </div>
      <div v-if="Flight" class="block-item btn-select mb-4">
        <div class="container">
          <div class="row flightinfo text-center">
            <div class="col-4">
              <div>{{ lang['homepage_new'].SFS_LANG_ROW_1 }}</div>
              <div class="airport-name">{{ Flight.dep }}</div>
              <div class="flight-time-der">
                {{ moment(Flight.std).format('D MMM') }}
                <div :style="Flight.etd ? 'text-decoration: line-through' : ''">
                  {{ moment(Flight.std).format('HH:mm') }}
                </div>
                <div v-if="Flight.etd">
                  {{ moment(Flight.etd).format('HH:mm') }}
                </div>
              </div>
            </div>
            <div class="col-4">
              <div>{{ Flight.carrier }}{{ Flight.flight_no }}</div>
              <div class="frame-flight-img" style="margin-top: 11pt">
                <img src="@/assets/images/flight.png" />
              </div>
              <div class="flight-status">
                <p style="color: #000">{{ lang['homepage_new'].SFS_LANG_ROW_3 }}:</p>
                <p v-if="pax.fltref !== pax.first_fltref" :class="{ 'status-new-flight': pax.fltref !== pax.first_fltref }">
                  {{ statusFlight }}
                </p>
                <p v-else class="status-flight">
                  <span v-if="Flight.irreg_reason">{{ lang['status_flight'][Flight.irreg_reason] || Flight.flight_status }}</span>
                  <span v-else>{{ lang['status_flight']['NO_IRREG'] || Flight.flight_status }}</span>
                </p>
                <p v-if="statusFlightDetail">{{ statusFlightDetail }}</p>
              </div>
            </div>
            <div class="col-4">
              <div>{{ lang['homepage_new'].SFS_LANG_ROW_2 }}</div>
              <div class="airport-name">{{ Flight.div }}</div>
              <div class="flight-time-arr">
                {{ moment(Flight.sta).format('D MMM') }}
                <div :style="Flight.eta ? 'text-decoration: line-through' : ''">
                  {{ moment(Flight.sta).format('HH:mm') }}
                </div>
                <div v-if="Flight.eta">
                  {{ moment(Flight.eta).format('HH:mm') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--SERVICES & VOUCHERS-->
      <h2 class="title">{{ pax['covid19_portal']['1'].SERVER_OFFER }}</h2>
      <div>
        <!--HOTEL-->
        <div v-if="Hotel" class="block-item btn-select">
          <div class="row align-items-center">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_hotel text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ Hotel.name ? Hotel.name : 'Hotel' }} {{ Hotel.blockdate ? Hotel.blockdate : '' }}
            </div>
          </div>
        </div>

        <!--REFRESHMENT-->
        <div v-if="Refreshment" class="block-item btn-select">
          <div class="row align-items-center">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_refreshment text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang['homepage_new'].SFS_LANG_ROW_21 }} {{ Refreshment.price_per_person }}
              <span>{{ Refreshment.currency }}</span>
            </div>
          </div>
        </div>

        <!--GROUP TRANSPORT-->
        <div v-if="Bus" class="block-item btn-select">
          <div class="row align-items-center">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_bus text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang['homepage_new'].SFS_LANG_ROW_22 }}
            </div>
          </div>
        </div>

        <!--TAXI-->
        <div v-if="Taxi" class="block-item btn-select">
          <div class="row align-items-center">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_taxi text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang['homepage_new'].SFS_LANG_ROW_23 }}
            </div>
          </div>
        </div>

        <!--TRAIN-->
        <div v-if="Train" class="block-item btn-select">
          <div class="align-items-center row">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_train text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang['homepage_new'].SFS_LANG_ROW_24 }}
            </div>
          </div>
        </div>

        <!--RENTAL CAR-->
        <div v-if="RentalCar" class="block-item btn-select">
          <div class="row align-items-center">
            <div class="col-3 col-md-2 pl-4">
              <i class="sb_mobile sb_car text-right"> </i>
            </div>
            <div class="item-title col-8 col-md-9">
              {{ lang['homepage_new'].SFS_LANG_ROW_25 }}
            </div>
          </div>
        </div>
      </div>
      <!-- Comment -->
      <div class="my-flight-updates">
        <section class="mt-4">
          <ul class="list-news-flight">
            <li v-for="(cmt, k) in Comment" :key="k" class="item-news-flight">
              <!-- eslint-disable-next-line vue/no-deprecated-filter -->
              <h2 class="title-news">{{ pax['covid19_portal']['1'].UPDATE }} {{ cmt.created | datetime() }}</h2>
              <div class="content-news" @click="readMore(k)">
                <div>
                  <div v-if="cmt.showFull">{{ cmt.content.substring(0, 50) + '...' }}</div>
                  <div v-else>{{ cmt.content }}</div>
                </div>
                <div class="text-right">
                  <span v-if="cmt.showFull">{{ pax['covid19_portal']['1'].READ_MORE }}</span>
                  <span v-else>{{ pax['covid19_portal']['1'].READ_LESS }}</span>
                </div>
              </div>
            </li>
          </ul>
        </section>
      </div>
    </div>
    <div v-show="!receiveMessage" class="bachgroup-drop"></div>
    <div v-show="!receiveMessage" class="popup-confirm container mt-5">
      <h3 class="mb-2">
        {{ pax['covid19_portal']['1'].CONFIRM_SHARE_MESSAGE_CONTENT.replace('&lt;passenger_name&gt;', pax.full_name) }}
      </h3>
      <p class="mt-2">
        <em>{{ pax['covid19_portal']['1'].CONFIRM_SHARE_MESSAGE_HEADER }}</em>
      </p>
      <button type="button" class="btn btn-lg btn-primary col-12 mt-3 border-radius-25" @click="updateReceiveMsgStatus(1)">
        {{ pax['covid19_portal']['1'].CONFIRM_SHARE_MESSAGE_YES }}
      </button>
      <br />
      <button type="button" class="btn btn-lg btn-primary col-12 mt-3 border-radius-25" @click="updateReceiveMsgStatus(2)">
        {{ pax['covid19_portal']['1'].CONFIRM_SHARE_MESSAGE_NO }}
      </button>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/Home.scss'
import '@/assets/scss/modules/MyFlightUpdates.scss'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'InfoFlightUpdate',
  filters: {
    datetime: function (date) {
      return moment(date).format('DD-MM-YYYY')
    }
  },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      Services: {},
      Refreshment: {},
      Hotel: {},
      Flight: {},
      Taxi: {},
      Bus: {},
      RentalCar: {},
      Train: {},
      Comment: {},
      receiveMessage: 0,
      statusFlightDetail: ''
    }
  },
  computed: {
    ...mapGetters({})
  },
  watch: {
    lang: function () {},
    pax: function (el) {
      if (el && el.receive_message) {
        this.checkService()
      }
    }
  },
  mounted() {
    if (this.pax && this.pax.receive_message) {
      this.checkService()
    }
  },
  methods: {
    readMore: function (k) {
      this.Comment[k].showFull = !this.Comment[k].showFull
      this.$forceUpdate()
    },
    updateReceiveMsgStatus: function (value) {
      let self = this
      self.$store
        .dispatch('InfoFlightUpdate/updateShareContact', { secret: self.secret, receive_message: value })
        .then((response) => {
          if (response && response.success) {
            self.receiveMessage = value
            self.$store.dispatch('updateReceiveMsg', value)
          }
        })
    },
    checkService: function () {
      this.receiveMessage = this.pax.receive_message.receive_message
      this.Flight = this.pax.flight
      this.Hotel = this.pax.hotel
      this.Services = this.pax.services
      this.Comment = this.pax.comment
      _.each(this.Comment, function (item) {
        item.showFull = true
      })
      if (!this.Hotel) {
        this.Hotel = _.find(this.Services, { service_id: 1 })
      }
      this.Refreshment = _.find(this.Services, { service_id: 2 })
      this.Bus = _.find(this.Services, { service_id: 3 })
      this.Taxi = _.find(this.Services, { service_id: 4 })
      this.Train = _.find(this.Services, { service_id: 5 })
      this.RentalCar = _.find(this.Services, { service_id: 6 })
    }
  }
}
</script>
